/**
 * Textos derivados del cierre que la oficina lee tal cual: el motivo de
 * bloqueo (que el backend guarda como JSON o texto libre) y los montos.
 */
import { formatCLP } from "../../lib/api";

/**
 * `motivo_bloqueo` en lenguaje de oficina.
 *
 * La revisión de lecturas guarda `{"bloqueantes": N, "faltantes": [ids]}`;
 * anular una lectura guarda una frase. Si es JSON se arma la frase; si no,
 * se muestra tal cual.
 */
export function describirMotivoBloqueo(motivo: string): string {
  let datos: unknown;
  try {
    datos = JSON.parse(motivo);
  } catch {
    return motivo;
  }
  if (datos === null || typeof datos !== "object" || Array.isArray(datos)) {
    return motivo;
  }
  const d = datos as { bloqueantes?: unknown; faltantes?: unknown };
  const faltantes = Array.isArray(d.faltantes) ? d.faltantes.length : 0;
  const bloqueantes = typeof d.bloqueantes === "number" ? d.bloqueantes : faltantes;
  const otros = Math.max(bloqueantes - faltantes, 0);

  const partes: string[] = [];
  if (faltantes > 0) {
    partes.push(
      `${faltantes.toLocaleString("es-CL")} ${faltantes === 1 ? "casa sin lectura impide" : "casas sin lectura impiden"} avanzar. ` +
        "Estímalas por término medio o ingresa sus lecturas.",
    );
  }
  if (otros > 0) {
    partes.push(
      `${otros.toLocaleString("es-CL")} ${otros === 1 ? "caso más impide" : "casos más impiden"} avanzar: revísalos en "Revisión de lecturas".`,
    );
  }
  return partes.length > 0 ? partes.join(" ") : "Hay casos que impiden avanzar.";
}

/** Un descuento: sin signo cuando es cero ("-$0" no es un monto). */
export function descuentoCLP(n: number): string {
  return n > 0 ? `-${formatCLP(n)}` : formatCLP(0);
}
